export const CRYPTO_SITES = [
  {
    name: 'FTX.com',
    icon: '/img/providers/ftx.svg',
    url: 'https://ftx.com',
  },
  {
    name: 'Coinbase',
    icon: '/img/providers/coinbase.png',
    url: 'https://coinbase.com',
  },
  {
    name: 'MoonPay',
    icon: '/img/providers/moonpay.svg',
    url: 'https://buy.moonpay.com/',
  },
  {
    name: 'Crypto.com',
    icon: '/img/providers/cryptocom.svg',
    url: 'https://crypto.com',
  },
  {
    name: 'Coinmama',
    icon: '/img/providers/coinmama.svg',
    url: 'https://coinmama.com',
  },
  {
    name: 'LocalBitcoins',
    icon: '/img/providers/localbitcoins.svg',
    url: 'https://localbitcoins.com',
  },
  {
    name: 'CashApp',
    icon: '/img/providers/cashapp.svg',
    url: 'https://cash.app',
  },
  {
    name: 'CEX.IO',
    icon: '/img/providers/cexio.svg',
    url: 'https://cex.io',
  },
]

export const CASH_PROVIDERS = [
  {
    name: 'VISA',
    icon: '/img/providers/visa.svg',
    iconSize: 96,
  },
  {
    name: 'Mastercard',
    icon: '/img/providers/mastercard.svg',
    iconSize: 96,
  },
  {
    name: 'PayPal',
    icon: '/img/providers/paypal.svg',
    iconSize: 128,
  },
  {
    name: 'Skrill',
    icon: '/img/providers/skrill.png',
    iconSize: 96,
  },
  {
    name: 'paysafecard',
    icon: '/img/providers/paysafecard.svg',
    iconSize: 128,
  },
  {
    name: 'WebMoney',
    icon: '/img/providers/webmoney.png',
    iconSize: 128,
  },
  {
    name: 'Google Pay',
    icon: '/img/providers/gpay.svg',
    iconSize: 128,
  },
  {
    name: 'Trustly',
    icon: '/img/providers/trustly.svg',
    iconSize: 128,
  },
]
